import HeaderNav from "@/layouts/HeaderNav";
import React, { useEffect, useState } from "react";
import PaymentsTable from "./PaymentsTable";
import { Payment, PreviewPdf, Transaction } from "./interface";
import FormModal from "@/components/modals/FormModal";
import StripePaymentForm from "./StripePaymentForm";
import StripeBTCForm from "./StripeBTCForm";
import { API_ROUTES } from "@/services/environment";
import { GET, POST } from "@/services/api";
import { useAppDispatch, useAppSelector } from "@/hooks/hook";
import TransactionTable from "./TransactionTable";
import downloadIcon from "@/assets/icons/download.svg";
import _DatePicker from "react-datepicker";
import useLoading from "@/hooks/useLoading";
import { Button, convertDollarToCents, Loader } from "@thdinc/hpf-shared";
import Lottie from "lottie-react";
import useDownloadPdf from "@/hooks/usePdfDownload";
import Alert from "@/components/alert/Alert";
import invoice from "@/assets/images/invoice.png";
import PaymentPreview from "@/components/pdfPaymentPreview/PaymentPreview";
import { IoMdArrowBack } from "react-icons/io";
import { resetPaymentForm } from "@/redux/slices/paymentFormSlice";
import { StoreList } from "../alcohalAndMixers/interface";
import Dropdown from "@/components/Dropdown/Dropdown";
import jsPDF, { HTMLOptions } from "jspdf";
import stripeIcon from "@/assets/icons/stripeIcon.svg";
import copyIcon from "@/assets/icons/copyIcon.svg";
import tickIcon from "@/assets/icons/tickIcon.svg";
import { amountTaxRate } from "@/utils";
import PaginationRow from "@/components/paginationRow/PaginationRow";
const BASE_URL: string = (process.env.REACT_APP_BASE_URL as string);
const DatePicker = _DatePicker as unknown as React.ComponentType<any>;

export const PaymentsPage = () => {
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [isPreviewLoading, setPreviewLoading] = useState<boolean>(false);
  const { getPaymentsApi, postPaymentPreviewApi, getStoresApi, updateStripeCard } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const [paymentList, setPamentList] = useState<Payment[]>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit] = useState(10);
  const [totalResults, setTotalResults] = useState(0);
  const [hasNext, setHasNext] = useState(false);
  const [currData, setCurrData] = useState<Payment>();
  const [rerender, setRerender] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [previewData, setPreviewData] = useState<PreviewPdf>({
    isPreview: false,
    invoiceData: null,
  });
  const [paymentInvoiceId, setPaymentInvoiceId] = useState<string>("");
  const [storeList, setStoresList] = useState<StoreList[]>([]);
  const [selectedValue, setSelectedValue] = useState<string | StoreList>("");
  const [selectedStore, setSelectedStore] = useState<StoreList>();
  const { loading, downloadPdf, downloadMultiPagePdf } = useDownloadPdf();
  const renderFun = () => {
    setRerender(!rerender);
  };
  // useEffect(() => setIsOpen(false), [])
  const getPayments = async (
    page = pageNumber,
    search = debouncedSearch,
    start: Date | null = startDate,
    end: Date | null = endDate
  ) => {
    try {
      startLoading();
      const params = new URLSearchParams();
      params.append("pageNumber", String(page));
      params.append("limit", String(limit));
      if (search) params.append("search", search);
      if (start && end) {
        params.append("start_date", start.toISOString());
        params.append("end_date", end.toISOString());
      }
      const res = await GET(`${getPaymentsApi}?${params.toString()}`, refreshToken);
      if (res?.data) {
        setPamentList(res.data.result ?? []);
        setTotalResults(res.data.totalResults ?? 0);
        setHasNext(res.data.hasNext ?? false);
        setPageNumber(res.data.pageNumber ?? page);
      }
    } catch (error) {
      console.log(error);
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    const getStores = async () => {
      try {
        const res = await GET(getStoresApi, refreshToken);
        if (res?.data?.length > 0) {
          setStoresList(
            res.data.concat({ id: "", name: "BTC", state: "btc", city: "" })
          );
          setSelectedValue(res.data[0]);
          setSelectedStore(res.data[0]);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getPayments();
    getStores();
  }, [rerender]);
  const selectCurrentPayment = (paymentId: string) => {
    const cur = paymentList.find((i: Payment) => i.id === paymentId);
    setCurrData(cur);
  };
  useEffect(() => {
    const selectedStore = storeList.find(
      (store) => store.name == selectedValue
    );
    selectedStore && setSelectedStore(selectedStore);
  }, [selectedValue]);
  // Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isLinkLoading, setIsLinkLoading] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const openCardModal = () => {
    setIsCardModalOpen(true);
    setStripeLink("");
  };
  const [stripeLink, setStripeLink] = useState("");
  const dispatch = useAppDispatch();
  const closeModal = () => {
    if (storeList?.length > 0) {
      setSelectedValue(storeList[0]);
      setSelectedStore(storeList[0]);
    }
    setIsOpen(false);
    setCurrTab("HOWS");
    setIsModalOpen(false);
    setIsOpen(false);
    setPreviewData({
      isPreview: false,
      invoiceData: null,
    });
    dispatch(resetPaymentForm());
  };
  // transaction modal
  const [tranModal, setTranModal] = useState(false);
  const openTransModal = () => setTranModal(true);
  const closeTransModal = () => {
    setTranModal(false);
  };
  const closeCardModal = () => {
    setIsCardModalOpen(false);
    setLinkCopied(false);
    setIsLinkLoading(false);
  };
  const handleLinkCopy = () => {
    if (!stripeLink) return;
    navigator.clipboard.writeText(stripeLink);
    setLinkCopied(true);
  };
  // --

  // tabs
  type Tab = "HOWS" | "BTC";
  const [currTab, setCurrTab] = useState<Tab>("HOWS");
  const changeTab = (tab: Tab) => {
    setCurrTab(tab);
  };
  // --
  // search functiionality
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 600);
    return () => clearTimeout(handler);
  }, [searchQuery]);
  // Range Functionality
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [startDate, endDate] = dateRange;
  const dateRangeFun = (update: [Date | null, Date | null]) => {
    setDateRange(update);
    const [start, end] = update;

    if ((start && end) || (!start && !end)) {
      setPageNumber(1);
      getPayments(1, debouncedSearch, start, end);
    }
  };
  useEffect(() => {
    setPageNumber(1);
    getPayments(1, debouncedSearch, startDate, endDate);
  }, [debouncedSearch]);
  const handlePrev = () => {
    if (pageNumber > 1) {
      const prevPage = pageNumber - 1;
      setPageNumber(prevPage);
      getPayments(prevPage, debouncedSearch, startDate, endDate);
    }
  };
  const handleNext = () => {
    if (hasNext) {
      const nextPage = pageNumber + 1;
      setPageNumber(nextPage);
      getPayments(nextPage, debouncedSearch, startDate, endDate);
    }
  };
  const currentStart = totalResults === 0 ? 0 : (pageNumber - 1) * limit + 1;
  const currentEnd = Math.min(pageNumber * limit, totalResults);
  const paymentInvoice = () => {
    downloadMultiPagePdf(paymentInvoiceId)
      .then((fileName) => {
        setPaymentInvoiceId("");
        setIsOpen(false);
        renderFun();
        closeModal();
        Alert({ message: "Invoice downloaded" });
      })
      .catch((err) => {
        setPaymentInvoiceId("");
        setIsOpen(false);
        console.log("Failed to download invoice PDF:", err);
      });
  };
  const handleOptionChange = (value: string) => {
    setSelectedValue(value);
    setCurrTab(value === "BTC" ? "BTC" : "HOWS");
    // dispatch(resetPaymentForm());
  };
  const onPreiewDownload = async () => {
    const { invoiceData } = previewData;
    const formData = new FormData();
    //table array values
    invoiceData?.spiritList.forEach((item: any, index: number) => {
      formData.append(`alcoholCharge[${index}][bottle_cost]`, convertDollarToCents(item.bottle_cost));
      formData.append(`alcoholCharge[${index}][number_of_bottles]`, item.number_of_bottles);
      formData.append(`alcoholCharge[${index}][bottle_total_amount]`, convertDollarToCents(item.bottle_total_amount));
      formData.append(`alcoholCharge[${index}][product_type]`, item.spirit_type);
      if (item.product_id == 'other') {
        formData.append(`alcoholCharge[${index}][product_id]`, String(null));
        formData.append(`alcoholCharge[${index}][name]`, item.brandName);
      } else {
        formData.append(`alcoholCharge[${index}][product_id]`, item.product_id);
        formData.append(`alcoholCharge[${index}][name]`, item.product_name);
      }
      // formData.append(`alcoholCharge[${index}][is_prefer]`, item.is_prefer);
    });
    //fixed values
    formData.append("business_id", String(currData?.business_id));
    formData.append("booking_id", String(currData?.id));
    formData.append("total_amount_charged", convertDollarToCents(invoiceData.preview_amount_charged));
    formData.append("hot_platform_fee", convertDollarToCents(String(invoiceData.hot_platform_fee)));
    formData.append("bartender_company_fee", convertDollarToCents(String(invoiceData.bartender_company_fee)));
    formData.append("tax_rate", convertDollarToCents(invoiceData?.taxRateTotal));
    formData.append("store_name", String(invoiceData?.selectedStore?.name));
    setPreviewLoading(true);
    try {
      const res = await POST(
        `${postPaymentPreviewApi}`,
        formData,
        refreshToken
      );
      if (res?.data) {
        if (res?.data?.success) {
          const htmlContent = res.data.page1;
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlContent, "text/html");
          const fullHtmlContent = doc.documentElement.outerHTML;
          const pdf = new jsPDF("p", "mm", "a4");
          pdf.setFont("courier", "italic");
          await pdf.html(fullHtmlContent, {
            x: 6,
            y: 10,
            width: 190,
            scale: 2,
            windowWidth: 800,
          } as HTMLOptions);

          const fileName = `invoice_preview.pdf`;
          pdf.save(fileName);
          Alert({ message: res?.data?.message });
        } else {
          Alert({
            type: "error",
            message: res?.data?.message ?? "Something went wrong",
          });
        }
      } else {
        Alert({
          type: "error",
          message: res?.data?.message ?? "Something went wrong",
        });
      }
    } catch (error) {
      Alert({ type: "error", message: "Something went wrong" });
    } finally {
      setPreviewLoading(false);
    }
  };
  const handleGenerateStripeCardLink = async () => {
    try {
      setLinkCopied(false);
      setIsLinkLoading(true);
      const res = await GET(`${updateStripeCard}/${currData?.id}`, refreshToken);
      setStripeLink(`${BASE_URL}payments/update-customer-card/${res?.data}`);
    } catch (error) {
      console.log('error-----------------:', error)
    } finally {
      setIsLinkLoading(false);
    }
  }

  return (
    <div>
      <HeaderNav>
        <div className="flex justify-between md:items-center items-start flex-wrap md:flex-row flex-col ">
          <h1 className="md:text-3xl text-xl text-gray-800 font-semibold ">
            Payments
          </h1>
          <div className="flex items-center gap-4 sm:flex-row flex-col w-full md:w-fit mt-4 md:mt-0 ">
            <input
              type="text"
              placeholder="Search Customer or Business Name"
              onChange={handleSearch}
              className=" md:min-w-80 w-full px-4 py-3 bg-white rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              name=""
            />
            <DatePicker
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              className=" cursor-pointer md:w-56 w-full px-4 py-3 bg-white rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              onChange={dateRangeFun}
              isClearable={true}
              placeholderText="Date Range"
            />
          </div>
        </div>
      </HeaderNav>
      {isLoading ? (
        <Loader color="bg-red-500" />
      ) : paymentList.length > 0 ? (
        <PaymentsTable
          payments={paymentList}
          selectCurrentPayment={selectCurrentPayment}
          openModal={openModal}
          openTransModal={openTransModal}
          openCardModal={openCardModal}
        // selectCurrentTrans={selectCurrentTrans}
        />
      ) : (
        <p className="text-center">No Item Found</p>
      )}
      {!isLoading && paymentList.length > 0 && (
        <PaginationRow
          onPrev={handlePrev}
          onNext={handleNext}
          disablePrev={pageNumber === 1}
          disableNext={!hasNext}
          currentStart={currentStart}
          currentEnd={currentEnd}
          total={totalResults}
        />
      )}
      <FormModal
        overflow="overflow-hidden "
        modalTitle={
          currTab === "HOWS" ? "Alcohol Charge" : "Additional Charge"
          // `${currData?.first_name} ${currData?.last_name} ` as string | "Name"
        }
        isOpen={isModalOpen}
        onClose={closeModal}
        width="lg:w-[55%] md:w-5/6 w-full"
        customHeader={
          //only visible this header in case of pdf preview open
          previewData.isPreview && (
            <div className="flex flex-row items-center text-primary-red justify-between w-full bg-white px-8 pb-1">
              <div
                onClick={() =>
                  setPreviewData({
                    isPreview: false,
                    invoiceData: null,
                  })
                }
                className="bg-[#F7F8FA] p-2 mt-4 md:mt-2 rounded-full cursor-pointer "
              >
                <IoMdArrowBack />
              </div>
              <Button
                type="button"
                disabled={isPreviewLoading}
                onClick={() => onPreiewDownload()}
                className={`text-center px-6 rounded-full py-2 ${"bg-primary-red hover:bg-primary-red-button-hover text-white mt-3 mr-1"}`}
              >
                {isPreviewLoading ? "Downloading..." : "Download"}
              </Button>
            </div>
          )
        }
      >
        {/* TABs */}
        {
          <div>
            {previewData.isPreview ? (
              <PaymentPreview
                setPreviewData={setPreviewData}
                previewData={previewData}
                currData={currData}
                setIsOpen={setIsOpen}
                setPaymentInvoiceId={setPaymentInvoiceId}
              />
            ) : !isOpen ? (
              <div>
                <div className="mt-3 mb-10 flex justify-center">
                  <Dropdown
                    options={storeList ?? []}
                    selectedValue={selectedValue}
                    onOptionChange={handleOptionChange}
                    isDarkMode
                  />
                  {/* <ul className="  flex   font-medium text-center text-gray-500  border-gray-400  bg-p-gray rounded-full w-fit p-1 mb-2 md:mb-0">
                    <button
                      onClick={() => changeTab("HOWS")}
                      aria-current="page"
                      className={`inline-block px-5 py-2      ${currTab === "HOWS" ? "text-white   bg-black rounded-full " : ""
                        }`}
                    >
                      HOWS
                    </button>
                    <li className="me-2 cursor-pointer">
                      <div
                        onClick={() => changeTab("BTC")}
                        className={`inline-block px-5 py-2 ${currTab === "BTC" ? "text-white   bg-black rounded-full " : ""
                          } `}
                      >
                        BTC
                      </div>
                    </li>
                  </ul> */}
                </div>
                {currData && (
                  <div>
                    {currTab === "HOWS" ? (
                      <StripePaymentForm
                        paymentInfo={currData}
                        closeModal={closeModal}
                        renderFun={renderFun}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        setPaymentInvoiceId={setPaymentInvoiceId}
                        setPreviewData={setPreviewData}
                        paymentInvoiceId={paymentInvoiceId}
                        selectedStore={selectedStore}
                      />
                    ) : (
                      <StripeBTCForm
                        paymentInfo={currData}
                        closeModal={closeModal}
                        renderFun={renderFun}
                      />
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="my-1">
                <div className="flex justify-center items-center flex-col">
                  <img src={invoice} className="w-32 h-w-32" />
                  <p className="text-center text-[#FF5100] my-3">
                    Amount Charged Successfully
                  </p>
                </div>
                <div className="flex justify-center items-center">
                  <Button
                    disabled={loading}
                    onClick={paymentInvoice}
                    className={`text-center  px-6 rounded-full mt-2 py-2 bg-primary-red hover:bg-primary-red-button-hover text-white`}
                  >
                    <div className="flex flex-direction-row items-center justify-center gap-3">
                      <span>{loading ? "Downloading..." : "Download"}</span>
                      {/* <span><img src={downloadIcon} className="invert" /></span> */}
                    </div>
                  </Button>
                </div>
              </div>
            )}
          </div>
        }
      </FormModal>

      {/* Transaction Table */}
      <FormModal
        overflow="overflow-hidden "
        modalTitle="Charges History"
        isOpen={tranModal}
        onClose={closeTransModal}
        width="lg:w-5/6 md:w-5/6 w-full"
      >
        {currData && <TransactionTable bookingId={currData?.id} />}
      </FormModal>
      <FormModal
        overflow="overflow-hidden"
        modalTitle="Update Card"
        isOpen={isCardModalOpen}
        onClose={closeCardModal}
        width="lg:w-1/3 md:w-5/6 w-full">
        <div>
          <img
            src={stripeIcon}
            alt="stripe icon"
            className="w-12"
          />
          {/* <h1 className="font-bold text-[#546cd6]">Stripe</h1> */}
          <h1 className="font-semibold text-sm mt-2">Update Card on Stripe</h1>
          <div className="relative">
            <input
              disabled
              value={stripeLink}
              maxLength={21}
              className="w-full px-4 py-3 mt-6 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
              placeholder={"Click on generate link"}
              onChange={(e) => {
                setStripeLink(e.target.value);
                setLinkCopied(false);
              }}
            />
            <button
              type="button"
              onClick={handleLinkCopy}
              className="absolute inset-y-0 right-3 top-6 flex items-center text-gray-400 hover:text-gray-600">
              {linkCopied ?
                <img
                  src={tickIcon}
                  alt="copy icon"
                  className="w-7 bg-white rounded-full"
                /> :
                <img
                  src={copyIcon}
                  alt="copy icon"
                  className="w-7"
                />}
            </button>
          </div>
          <div className="flex justify-end mt-6">
            <Button
              type="button"
              disabled={isLoading || stripeLink.length > 0 ? true : false}
              onClick={() => handleGenerateStripeCardLink()}
              className={`text-center px-6 rounded-full py-2
              ${"text-white"} ${stripeLink.length > 0 ? "cursor-not-allowed bg-gray-400 hover:bg-gray-400" : "bg-primary-red hover:bg-primary-red-button-hover"}`}>
              {isLinkLoading ? "Generating Link..." : "Generate Link"}
            </Button>
          </div>
        </div>
      </FormModal>
    </div>
  );
};
